import * as React from "react"
import type { SVGProps } from "react"
const SvgCheckCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.6 13.8-2.15-2.15a1 1 0 0 0-.7-.28 1 1 0 0 0-.7.28 1 1 0 0 0-.28.7q0 .43.28.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65a1 1 0 0 0 .28-.7 1 1 0 0 0-.28-.7 1 1 0 0 0-.7-.28 1 1 0 0 0-.7.28zM12 22a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17A10 10 0 0 1 2 12q0-2.07.79-3.9a10 10 0 0 1 2.14-3.17Q6.28 3.56 8.1 2.78A10 10 0 0 1 12 2q2.07 0 3.9.79a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.17A10 10 0 0 1 22 12a10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.18q-1.34 1.34-3.17 2.13A10 10 0 0 1 12 22" />
  </svg>
)
export default SvgCheckCircleFilled
